import * as THREE from 'three';

interface Glow { sprite: THREE.Sprite; base: number; flicker: number; night: number; phase: number }

/**
 * Soft additive halos stand in for real lights around fires, lanterns, windows and
 * glowing ore. A sprite costs almost nothing; a real point light costs every pixel it touches.
 */
export class Glows {
  private list: Glow[] = [];
  readonly tex: THREE.Texture;
  constructor(private scene: THREE.Scene) {
    const c = document.createElement('canvas'); c.width = c.height = 64;
    const g = c.getContext('2d')!, grad = g.createRadialGradient(32, 32, 0, 32, 32, 32);
    grad.addColorStop(0, 'rgba(255,255,255,1)'); grad.addColorStop(0.25, 'rgba(255,255,255,0.55)'); grad.addColorStop(0.6, 'rgba(255,255,255,0.12)'); grad.addColorStop(1, 'rgba(255,255,255,0)');
    g.fillStyle = grad; g.fillRect(0, 0, 64, 64);
    this.tex = new THREE.CanvasTexture(c);
  }
  /** `night` = how much brighter it gets after dark (0 = constant). */
  add(x: number, y: number, z: number, color: number, size: number, opts: { flicker?: number; night?: number; base?: number } = {}) {
    const mat = new THREE.SpriteMaterial({ map: this.tex, color, blending: THREE.AdditiveBlending, depthWrite: false, transparent: true, fog: true });
    const s = new THREE.Sprite(mat);
    s.position.set(x, y, z); s.scale.setScalar(size); s.renderOrder = 3;
    this.scene.add(s);
    this.list.push({ sprite: s, base: opts.base ?? 0.6, flicker: opts.flicker ?? 0, night: opts.night ?? 0.4, phase: Math.random() * 10 });
    return s;
  }
  /** Take a halo away for good (a rich vein worked out). */
  remove(s: THREE.Sprite) {
    const i = this.list.findIndex(g => g.sprite === s);
    if (i >= 0) this.list.splice(i, 1);
    this.scene.remove(s); (s.material as THREE.SpriteMaterial).dispose();
  }
  update(time: number, night: number) {
    for (const g of this.list) {
      const f = g.flicker ? 1 - g.flicker * 0.5 + Math.sin(time * 11 + g.phase) * g.flicker * 0.25 + Math.sin(time * 23 + g.phase * 2) * g.flicker * 0.25 : 1;
      (g.sprite.material as THREE.SpriteMaterial).opacity = Math.min(1, (g.base + g.night * night) * f);
    }
  }
}
